<div class="setup-wrapper">
    <img class="logo" src="../../../assets/svg/FieldEx_Logo_Black_NoBorder.svg" alt="FieldEx Logo" />

    <div class="setup-left">
        <div class="form-section">
            <h2>Confirm Your Company</h2>
            <p class="subtitle">
                This will be displayed on the top bar of the web application and will be seen by all users in your organization
            </p>

            <form [formGroup]="companyForm">
                <div class="form-field">
                    <label for="companyName">Company Name</label>
                    <div class="input-wrapper">
                        <i class="fa-solid fa-building icon"></i>
                        <input pInputText id="companyName" type="text"  [(ngModel)]="formData.company" formControlName="companyName" placeholder="e.g. Stark Industries" autocomplete="off"/>
                    </div>
                     <div *ngIf="companyForm.controls['companyName'].touched && companyForm.controls['companyName'].invalid">
                            <span class="text-10 p-error" *ngIf="companyForm.controls['companyName'].errors?.required" id="label_SetInvLocNameReqField" >Required Field</span>
                            <span class="text-10 p-error" *ngIf="companyForm.controls['companyName'].errors?.maxlength" id="label_SetInvLocNameLessThan">Text exceeds character limit (255).</span>
                    </div>
                </div>
                <div class="button-row">
                    <button type="button" class="next" [disabled]="submitTouched" (click)="onSubmitCompanyName()">Next</button>
                </div>
            </form>

        </div>

        <!-- Optional: Step progress indicator -->
        <div class="step-indicator">
            <div class="steps">
                <span
                class="dot"
                *ngFor="let n of [1, 2, 3]"
                [class.active]="n == currentStep"
                [@dotAnim]="n === currentStep ? 'active' : 'inactive'">
                </span>
            </div>
            <span class="step-label">Step {{ currentStep }}/3</span>
        </div>
    </div>

    <div class="setup-right">
        <div class="ui-preview">
            <div class="preview-shell">
                <aside class="preview-sidebar">
                    <div class="preview-logo">
                        <img src="../../../assets/svg/FieldEx_Logo_White_NoBorder.svg" class="header-logo">
                    </div>
                    <ul class="preview-nav">
                        <li>
                            <div class="icon-wrap">
                                <img class="icon-logo" src="assets/svg/sidebar/task.svg">
                            </div>
                            <span>Tasks</span>
                        </li>
                        <li>
                            <div class="icon-wrap">
                                <img class="icon-logo" src="assets/svg/sidebar/job-order.svg">
                            </div>
                            <span>Job Orders</span>
                        </li>
                        <li>
                            <div class="icon-wrap">
                                <img class="icon-logo" src="assets/svg/sidebar/customer.svg">
                            </div>
                            <span>Customers</span>
                        </li>
                    </ul>
                    <div class="preview-footer">
                        <i class="fa-regular fa-gear"></i>
                        <i class="fa-regular fa-book-open"></i>
                    </div>
                </aside>

                <main class="preview-main">
                    <header class="preview-header">
                        {{ companyForm.get('companyName')?.value || 'Company Name' }}
                    </header>
                    <section class="preview-content">
                        <!-- Empty grey content space -->
                    </section>
                </main>
            </div>

        </div>
    </div>
</div>